<template>
  <FormCreate
    :errors="errors"
    :fields="fields"
    model="grouping"
    @submitted="create"
  >
    <div class="elr-form-row">
      <InputText
        label="Grouping Name"
        v-model="formData.name"
        fieldName="name"
        :errors="errors"
        :errorMessage="(errors && errors.name) ? errors.name[0] : null"
        :required=true
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Year"
        v-model="formData.year_id"
        fieldName="year_id"
        :errors="errors"
        :errorMessage="(errors && errors.year_id) ? errors.year_id[0] : null"
        :required=true
        :values="years"
      />
      <button @click.prevent="showYearModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Generation"
        v-model="formData.generation_id"
        fieldName="generation_id"
        :errors="errors"
        :errorMessage="(errors && errors.generation_id) ? errors.generation_id[0] : null"
        :required=true
        :values="generations"
      />
      <button @click.prevent="showGenerationModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Brand"
        v-model="formData.brand_id"
        fieldName="brand_id"
        :errors="errors"
        :errorMessage="(errors && errors.brand_id) ? errors.brand_id[0] : null"
        :required=true
        :values="brands"
      />
      <button @click.prevent="showBrandModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Release"
        v-model="formData.release_id"
        fieldName="release_id"
        :errors="errors"
        :errorMessage="(errors && errors.release_id) ? errors.release_id[0] : null"
        :required=true
        :values="releases"
      />
      <button @click.prevent="showReleaseModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Manufacturer"
        v-model="formData.manufacturer_id"
        fieldName="manufacturer_id"
        :errors="errors"
        :errorMessage="(errors && errors.manufacturer_id) ? errors.manufacturer_id[0] : null"
        :required=true
        :values="manufacturers"
      />
      <button @click.prevent="showManufacturerModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Origin"
        v-model="formData.origin_id"
        fieldName="origin_id"
        :errors="errors"
        :errorMessage="(errors && errors.origin_id) ? errors.origin_id[0] : null"
        :required=true
        :values="origins"
      />
      <button @click.prevent="showOriginModal = true" class="icon-button"><i class="fa fa-plus"></i></button>
    </div>
    <div class="elr-form-row">
        <InputTextArea
          label="Description"
          v-model="formData.description"
          fieldName="description"
          :errorMessage="(errors && errors.description) ? errors.description[0] : null"
        />
    </div>
    <ModalWindow
      @close="showGenerationModal = false"
      v-if="showGenerationModal"
      modalId="generationModal"
      :showFooter="false"
      heading="Add a Generation"
    >
      <FormGenerationCreate @submitted="showGenerationModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showManufacturerModal = false"
      v-if="showManufacturerModal"
      modalId="manufacturerModal"
      :showFooter="false"
      heading="Add a Manufacturer"
    >
      <FormManufacturerCreate @submitted="showManufacturerModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showReleaseModal = false"
      v-if="showReleaseModal"
      modalId="releaseModal"
      :showFooter="false"
      heading="Add a Release"
    >
      <FormReleaseCreate @submitted="showReleaseModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showOriginModal = false"
      v-if="showOriginModal"
      modalId="originModal"
      :showFooter="false"
      heading="Add a Origin"
    >
      <FormOriginCreate @submitted="showOriginModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showYearModal = false"
      v-if="showYearModal"
      modalId="yearModal"
      :showFooter="false"
      heading="Add a Year"
    >
      <FormYearCreate @submitted="showYearModal = false" />
    </ModalWindow>
    <ModalWindow
      @close="showBrandModal = false"
      v-if="showBrandModal"
      modalId="brandModal"
      :showFooter="false"
      heading="Add a Brand"
    >
      <FormBrandCreate @submitted="showBrandModal = false" />
    </ModalWindow>
  </FormCreate>
</template>

<script>
import { mapActions } from 'vuex';
import { validate } from '../../utils/validation';
import FormCreate from '../FormCreate/FormCreate';
import FormGenerationCreate from '../FormGenerationCreate/FormGenerationCreate';
import FormReleaseCreate from '../FormReleaseCreate/FormReleaseCreate';
import FormOriginCreate from '../FormOriginCreate/FormOriginCreate';
import FormManufacturerCreate from '../FormManufacturerCreate/FormManufacturerCreate';
import FormBrandCreate from '../FormBrandCreate/FormBrandCreate';
import FormYearCreate from '../FormYearCreate/FormYearCreate';
import InputSelect from '../InputSelect/InputSelect';
import InputText from '../InputText/InputText';
import InputTextArea from '../InputTextArea/InputTextArea';
import ModalWindow from '../ModalWindow/ModalWindow';

export default {
  name: 'FormGroupingCreate',
  data() {
    return {
      formData: {
        name: null,
        description: null,
        brand_id: null,
        generation_id: null,
        manufacturer_id: null,
        release_id: null,
        year_id: null,
        origin_id: null
      },
      showYearModal: false,
      showGenerationModal: false,
      showBrandModal: false,
      showReleaseModal: false,
      showOriginModal: false,
      showManufacturerModal: false,
      fields: [
        {
          name: 'name',
          rules: 'required',
          label: 'Grouping Name',
          type: 'text'
        },
        {
          name: 'description',
          label: 'Description',
          type: 'textarea'
          // rules: 'required'
        },
        {
          name: 'brand_id',
          rules: 'required',
          type: 'select',
          label: 'Brand'
        },
        {
          name: 'generation_id',
          rules: 'required',
          type: 'select',
          label: 'Generation'
        },
        {
          name: 'manufacturer_id',
          rules: 'required',
          type: 'select',
          label: 'Manufacturer'
        },
        {
          name: 'release_id',
          rules: 'required',
          type: 'select',
          label: 'Release'
        },
        {
          name: 'year_id',
          rules: 'required',
          type: 'select',
          label: 'Year'
        },
        {
          name: 'origin_id',
          rules: 'required',
          type: 'select',
          label: 'Origin'
        },
      ]
    };
  },
  components: {
    FormCreate,
    FormGenerationCreate,
    FormBrandCreate,
    FormReleaseCreate,
    FormOriginCreate,
    FormManufacturerCreate,
    FormYearCreate,
    InputSelect,
    InputText,
    InputTextArea,
    ModalWindow,
  },
  mounted() {
    this.$store.dispatch('brand/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('release/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('manufacturer/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('year/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('generation/FETCH_ALL', {
      num: -1
    });
    this.$store.dispatch('origin/FETCH_ALL', {
      num: -1
    });
  },
  computed: {
    errors() {
      return this.$store.state.grouping.errors ? this.$store.state.grouping.errors[0] : {};
    },
    brands() {
      const brands = this.$store.getters['brand/getAll'];

      return brands.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    releases() {
      const releases = this.$store.getters['release/getAll'];

      return releases.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    manufacturers() {
      const manufacturers = this.$store.getters['manufacturer/getAll'];

      return manufacturers.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    generations() {
      const generations = this.$store.getters['generation/getAll'];

      return generations.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    origins() {
      const origins = this.$store.getters['origin/getAll'];

      return origins.map(o => {
        return {
          value: o.id,
          label: o.name
        }
      })
    },
    years() {
      const years = this.$store.getters['year/getAll'];

      return years.map(o => {
        return {
          value: o.id,
          label: o.year_made
        }
      })
    }
  },
  methods: {
    ...mapActions('grouping', ['ADD', 'SET_ERROR', 'RESET_ERRORS']),
    validate(data) {
      const errors = validate(this.fields, data);

      if (this.hasErrors(errors)) {
        this['SET_ERROR']({ errors });
        this.$emit('error', { errors });

        return true
      }

      return false;
    },
    hasErrors(errors) {
      if (errors) {
        return !!Object.keys(errors).length;
      }

      return false;
    },
    inErrors(errors, field) {
      if (!this.hasErrors(errors)) {
        return;
      }

      const keys = Object.keys(errors);

      return keys.includes(field)
    },
    resetForm() {
      this.formData = {
        name: null,
        description: null,
        brand_id: null,
        generation_id: null,
        manufacturer_id: null,
        release_id: null,
        year_id: null,
        origin_id: null
      };
    },
    create() {
      if (this.validate(this.formData)) {
        return;
      }

      this['ADD'](this.formData);
      this['RESET_ERRORS']();
      this.$emit('submitted', { data: this.formData });
    },
  }
};
</script>
